// ONE PASS FOR A SEE-THROUGH, DOUBLE-SIDED SURFACE.
//
// Every fragment the exporter writes is double-sided (FragmentGlbWriter
// .WithDoubleSide(true)), and a blended one arrives transparent. three
// 0.164 draws a material that is transparent AND DoubleSide in TWO calls
// unless forceSinglePass is set (WebGLRenderer.renderObject: back faces,
// then front faces, flipping material.side and needsUpdate twice per
// draw). That was the whole of Tom's constant passFactor 1.13-1.14 on a
// real GPU, round 9: GPU calls minus census calls was 216 / 228, and the
// blend batches alone were 210 / 220 calls; the rest were blended pools.
//
// The two-pass order exists so a closed translucent solid shows its far
// side under its near side. Here the blended surfaces are glazing and
// clearance shells drawn without depth writes, coloured per element, so
// the order of the two layers changes only their shading, not what is
// visible - and it doubled the call and the program check for every one.
import { DoubleSide } from 'three';

// Would three draw this material twice per object?
export function drawsTwice(material) {
  return !!(material && material.transparent === true && material.side === DoubleSide
    && material.forceSinglePass !== true);
}

// Make it one draw. Returns the material for chaining.
export function singlePassBlend(material) {
  if (drawsTwice(material)) material.forceSinglePass = true;
  return material;
}
